module.exports = __webpack_public_path__ + "img/no-img-sq.cac3c471.jpg";